import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { FieldWorkerDashboard } from '../components/dashboard/FieldWorkerDashboard';
import { ForemanDashboard } from '../components/dashboard/ForemanDashboard';
import { AdminDashboard } from '../components/dashboard/AdminDashboard';
import { TruckDriverDashboard } from '../components/dashboard/TruckDriverDashboard';
import { TruckerDay } from '../components/modules/TruckerDay';

export const Home: React.FC = () => {
  const auth = useContext(AuthContext);

  if (!auth?.user) {
    return <div>Loading...</div>;
  }

  switch (auth.user.role) {
    case 'admin':
      return <AdminDashboard />;
    case 'foreman':
    case 'asphalt_foreman':
      return <ForemanDashboard />;
    case 'cdl_driver':
      return <TruckDriverDashboard />;
    // GPS-first flow (2026-07-16): Start Day = clock-in + truck pick; the haul
    // detector builds the day; End Day = clock-out + GPS timecard split. The old
    // manual TruckDriverDashboard stays for the legacy cdl_driver role only.
    case 'truck_driver':
      return <TruckerDay />;
    case 'field_worker':
    default:
      return <FieldWorkerDashboard />;
  }
};
